import { autreMissingNifReason } from '../components/step5/Options'
import { IStep5Props } from '../interfaces/Step5'
import { useTriggerChangeHook } from './triggerChangeHook'
import { getItemSuffix } from '../utils/getItemSuffix'

const Step5NifHook = (props: IStep5Props) => {
  const { form, folderData, item } = props
  const { watch } = form
  const nif_is_available = folderData[`nif_is_available${getItemSuffix(item)}`]
  const motif_absence_nif =
    folderData[`motif_absence_nif${getItemSuffix(item)}`]
  const watchNifIsAvailable: string = watch(
    `nif_is_available${getItemSuffix(item)}`,
    nif_is_available
  )
  const watchMotifAbsenceNif: string = watch(
    `motif_absence_nif${getItemSuffix(item)}`,
    motif_absence_nif
  )
  useTriggerChangeHook(`motif_absence_nif${getItemSuffix(item)}`)

  const nifIsAvailableFalse = watchNifIsAvailable === '1'
  const nifIsAvailableTrue = watchNifIsAvailable === '0'
  const motifAbsenceNifAutre = watchMotifAbsenceNif === autreMissingNifReason

  return {
    nifIsAvailableFalse,
    nifIsAvailableTrue,
    motifAbsenceNifAutre,
  }
}

export default Step5NifHook
